import { Invoice as InvoiceProps } from "@/lib/types/billing";
import { Button } from "./ui/button";
import { DownloadSimple } from "@phosphor-icons/react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "./ui/tooltip";

interface InvoiceCompopnentProps {
  invoice: InvoiceProps;
}

function Invoice({ invoice }: InvoiceCompopnentProps) {
  const formatDate = (timestamp: string) => {
    const date = new Date(0);
    date.setUTCSeconds(parseInt(timestamp));
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
    });
  };

  const periodStart = new Date(0);
  const periodEnd = new Date(0);
  const currentDate = new Date(0);

  periodStart.setUTCSeconds(parseInt(invoice.period_start));
  periodEnd.setUTCSeconds(parseInt(invoice.period_end));
  currentDate.setUTCSeconds(parseInt(invoice.created));

  const splitDate = periodStart
    .toLocaleDateString("en-GB", {
      day: "numeric",
      year: "numeric",
      month: "short",
    })
    .split(" ");

  return (
    <li className="flex flex-row items-center justify-between gap-2 p-4 border-b border-border last:border-none">
      <span>{`Invoice ${formatDate(invoice.created)}`}</span>
      <span className="ml-auto">{splitDate.join(" ")}</span>
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              variant="ghost"
              onClick={() => {
                let url = invoice.invoice_pdf;
                window.open(url, "_blank");
              }}
            >
              <DownloadSimple size={24} weight="bold" />
            </Button>
          </TooltipTrigger>
          <TooltipContent>Download</TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </li>
  );
}

export default Invoice;
